type TApiHeaders = Record<string, string>

/**
 * getHeaders
 * ? Получить заголовки
 *
 * @param {TApiHeaders} headers дополнительные заголовки
 * @returns {TApiHeaders} заголовки
 */
export const getHeaders = (headers?: TApiHeaders) => {
  const HEADERS = {
    'Content-Type': 'application/json',
    'X-Pingother': 'pingpong', // Нестандартный заголовок поддерживающий механизма Cross-Origin Resource Sharing (CORS). Помогает снизить риски, которые связаны с запросами из других источников, и обеспечивает передачу данных между браузером и веб-серверами по защищённому соединению.
  }

  return Object.assign(HEADERS, headers)
}
